const routes = {
  '/': 'หน้าหลัก',
  '/dashboard': 'หน้าหลัก',
  '/login': 'Login',
  '/#/login': 'Login',
  '/components': 'Components',
  '/charts': 'Charts',
  '/components/buttons': 'Buttons',
  '/components/social-buttons': 'Social Buttons',
  '/components/cards': 'Cards',
  '/components/forms': 'Forms',
  '/components/modals': 'Modals',
  '/components/switches': 'Switches',
  '/components/tables': 'Tables',
  '/components/tabs': 'Tabs',
  '/icons': 'Icons',
  '/icons/font-awesome': 'Font Awesome',
  '/icons/simple-line-icons': 'Simple Line Icons',
  '/cars/list': 'ข้อมูลรถ',
  '/cars/new': 'เพิ่มข้อมูลรถ',
  '/cars/detail/': 'รายละเอียดรถ',
  '/car-repair/list': 'ข้อมูลการซ่อมบำรุงรถ',
  '/car-repair/new': 'ข้อมูลการซ่อมบำรุง',
  '/customer/list': 'ข้อมูลลูกค้า',
  '/sales/list': 'ข้อมูลการขายรถ',
  '/car-sell/detail/': 'รายละเอียดการขายรถ',
  '/debtors/list': 'ข้อมูลบัญชีลูกหนี้',
  '/debtors/payment-detail/': 'รายละเอียดผ่อนชำระ',
  '/carfinance/list': 'CarFinanceList',
  '/bank/list': 'ข้อมูลธนาคาร',
  '/maintenance/list': 'ข้อมูลศูนย์ซ่อมบำรุง',
  '/calendar/list': 'ปฏิทินเตือนความจำ',
  '/branch/list': 'ข้อมูลสาขา',
  '/account/list': 'ข้อมูลผู้ใช้งาน',
  '/cars/book': 'การจองรถ',
  '/cars/book-cancel': 'ยกเลิกการจอง',
  '/sales/buy/': 'การขายรถ',
  '/employee/list': 'ข้อมูลพนักงาน',
  '/expense/list': 'ค่าใช้จ่ายของเต็นท์รถ',
  '/receipts/list': 'รายรับของเต็นท์รถ',
  '/car-reservation/list': 'ข้อมูลการจองรถ',
  '/sales/claim': 'ออกใบเคลม',
  '/car-claim/list': 'รายการเคลมรถ',
  '/sparepart': 'ข้อมูลอะไหล่',
  '/carin/all': 'ข้อมูลรถในเต็นท์',
  '/customer/findcar': 'ลูกค้าหารถ',
  '/customer/findcar/add': 'เพิ่มลูกค้าหารถ',
  '/calendar/manage': 'จัดการปฏิทินนัดหมาย',
  '/finance-pending/list': 'ข้อมูลรอจัดไฟแนนซ์',
  '/finance-pending/add/': 'เพิ่มข้อมูลจัดไฟแนนซ์',

}
export default routes
